/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./smartGroupCard.vue?vue&type=template&id=570957c2&scoped=true&"
import script from "./smartGroupCard.vue?vue&type=script&lang=js&"
export * from "./smartGroupCard.vue?vue&type=script&lang=js&"
import style0 from "./smartGroupCard.vue?vue&type=style&index=0&id=570957c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570957c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
